import script from "./SecStoryGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./SecStoryGrid.vue?vue&type=script&setup=true&lang=js"

import "./SecStoryGrid.vue?vue&type=style&index=0&id=4c657ee0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c657ee0"]])

export default __exports__